import { render, staticRenderFns } from "./PartOfFilter.vue?vue&type=template&id=4353b9e0&"
import script from "./PartOfFilter.vue?vue&type=script&lang=js&"
export * from "./PartOfFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports